// extracted by mini-css-extract-plugin
module.exports = {"card":"card--3fVwx","card_main":"card_main--2NG2Q","soft_btn":"soft_btn--2LTeQ","soft_btn_busing":"soft_btn_busing--7SlPY","soft_button_open":"soft_button_open--2LG_o"};